/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { blank } from "utils/generic";
import { getScreenRight } from "utils/generic";
import { useDispatch } from "react-redux";
import { getPlanFeatureById } from "utils/superAdminApi";
import { validateField } from "utils/generic";
import { addPlanFeatureData } from "utils/superAdminApi";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { updatePlanFeatureData } from "utils/superAdminApi";
import { fetchPlanNames } from "utils/superAdminApi";
import { generateDataList } from "utils/generic";
import { fetchFeatureNames } from "utils/superAdminApi";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

let fetchedPlanFeature;
let gfeatureType = "Count Based";

let routePath = "/subscriptionPlan";

function AddPlanFeatures() {

  const { id } = useParams();
  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [screenName, setScreenName] = useState("Add New Plan Feature");
  const [featureCountErr, setFeatureCountErr] = useState(false);
  const [featureBasedErr, setFeatureBasedErr] = useState(false);
  const [featureNames, setFeatureNames] = useState(false);
  const [featureList, setFeatureList] = useState([]);
  const [feature, setFeature] = useState("Count Based");
  const [planNames, setPlanNames] = useState([]);
  const [disableColor, setDisableColor] = useState(false);

  const [values, setValues] = React.useState({
    planID: "",
    featureID: "",
    featureType: "Count Based",
    featureCount: "",
    fromSlabValue: "",
    toSlabValue: "",
    slabRate: "",
    slabWiseList: [],
    featureName: "",
    featureSequence: "",
    featureStatus: "",
    selectionBasedValue: "Yes",
  });


  const handleChange = (name) => (event) => {
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };


  useEffect(() => {
    id === undefined ? setScreenName("Add New Plan Feature") : setScreenName("Edit Plan Feature");
    (async () => {
      getRight()
      await fetchPlanNamesData();
      await fetchFeatureNamesData();
      if (id !== undefined) {
        values._id = id
        getPlanFeatureById(values, (data) => {
          fetchedPlanFeature = data.Result_Output;
          if (fetchedPlanFeature.length > 0) {
            if (!fetchedPlanFeature[0].selectionBasedValue) {
              fetchedPlanFeature[0].selectionBasedValue = "Yes";
            }
            fetchedPlanFeature[0].featureType = gfeatureType
            setValues(fetchedPlanFeature[0]);
          }
        }, dispatch)
      }
    }
    )();
  }, [dispatch])


  async function getRight() {
    let right = await getScreenRight("Standard Plan Features")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)
  }


  const clearErrorStates = () => {
    setFeatureCountErr(false);
  };

  const planFeature = async () => {
    let mandateFlag = false;
    clearErrorStates();
    if (values.featureType === "Count Based") {
      values.selectionBasedValue =""
      mandateFlag = validateField(values.featureCount, setFeatureCountErr, mandateFlag)
    }else if(values.featureType === "Selection Based"){
      mandateFlag = validateField(values.selectionBasedValue, setFeatureBasedErr, mandateFlag)
      
    }
    if (mandateFlag) {
      return;
    }
    
    const apiFunction = id === undefined ? addPlanFeatureData : updatePlanFeatureData;
    apiFunction(values, (data) => {
      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath, cancelClicked());
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };

  function cancelClicked() {
    sessionStorage.setItem("SUBSCRIPTION_PLANS_STORAGE", "plan_feature");

  }

  const fetchPlanNamesData = async () => {
    fetchPlanNames(values, async (data) => {
      if (data.Result_Output.length > 0) {
        values.planID = data.Result_Output[0]._id;
      }
      setPlanNames(await generateDataList(data.Result_Output, "_id", "planName"));
    });
  };

  const fetchFeatureNamesData = async () => {
    fetchFeatureNames(values, async (data) => {
      if (data.Result_Output.length > 0) {
        values.featureID = data.Result_Output[0]._id;
      }
      setFeatureList(data.Result_Output)
      setFeatureNames(await generateDataList(data.Result_Output, "_id", "featureName"));
    });
  };

useEffect(()=>{
  for(let data of featureList){
   if(data._id === values.featureID){
    values.featureType  = data.featureType
    setFeature(data.featureType)
   }
  }
},[values.featureID])
  return (
    <DashboardLayout>
      <DashboardNavbar screenName={screenName} />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={1} style={{ display: "flex", justifyContent: "center" }}>
          <Grid item lg={8} xs={12}>
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>
              <Grid
                container
                p={1.6}
                mb={0.9}
                px={2}
                columnSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
                rowSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
              >
                <Grid item lg={6} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="userStatus">Plan Name</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ minHeight: "44.11px" }}
                      label="Plan Name"
                      value={values.planID}
                      onChange={handleChange("planID")}
                      autoFocus={true}
                    >
                      {planNames}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item lg={6} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="userStatus">Feature Name</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ minHeight: "44.11px" }}
                      label="Feature Name"
                      value={values.featureID}
                      onChange={handleChange("featureID")}
                      disabled={id !== undefined}
                    >
                      {featureNames}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item lg={6} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="userStatus">Feature Type</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ minHeight: "44.11px" }}
                      label="Feature Type"
                      value={feature}
                      onChange={handleChange("featureType")}
                      disabled
                    >
                      <MenuItem value="Count Based">Count Based</MenuItem>
                      <MenuItem value="Selection Based">Selection Based - Yes/No</MenuItem>
                      <MenuItem value="Range Based">Range Based</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {feature === "Count Based" && (
                  <Grid item lg={6} xs={12}>
                    <TextField
                      type="text"
                      label="Feature Count"
                      variant="outlined"
                      fullWidth
                      value={values.featureCount}
                      inputProps={{
                        pattern: "^[0-9]+$",
                        maxLength: 4
                      }}
                      onChange={handleChange("featureCount")}
                    />
                    {featureCountErr ? <span style={errMsg}>Feature Count can't be blank</span> : ""}
                  </Grid>
                )}
                {feature === "Selection Based" && (
                  <Grid item lg={6} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="userStatus">Selection Based</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ minHeight: "44.11px" }}
                        label="Selection Based"
                        value={values.selectionBasedValue}
                        onChange={handleChange("selectionBasedValue")}
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                    </FormControl>
                    {featureBasedErr ? <span style={errMsg}>Selection Based can't be blank</span> : ""}
                  </Grid>
                )}

              </Grid>
            </Card>
            <Height val={15} />
          </Grid>
        </Grid>
        <Grid
          container
          mt={2}
          columnSpacing={{ xs: 2, md: 4, lg: 4 }}
          // columnSpacing={4}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} lg={1.67}>
            <Link to={"/subscriptionPlan"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                onClick={() => { sessionStorage.setItem("PARA_TABLE", "plan_feature"); }}
                style={{ width: "165px", height: "40px" }}
              >
                Cancel
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} lg={1.67}>
            <MDButton
              onClick={
                disableColor ? blank : planFeature
              }
              rel="noreferrer"
              variant="gradient"
              className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
              color={disableColor ? "secondary" : "success"}
              fullWidth
              style={{ width: "165px", height: "40px" }}
            >
              {id !== undefined ? <>Update</> : <>Save</>}
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>

    </DashboardLayout>
  );
}

export default AddPlanFeatures;
